<template>
    <default-sidebar :active="$store.state.sidebars.showOfflineCardsList" :title="$t('cards.offline_title')">
        <div v-if="$store.state.sidebars.showOfflineCardsList" class="offline-cards-list-sidebar">
            <card-boxes-container
                v-if="offlineCards.length"
                :data="offlineCards"
                :disable-actions="true"
                :offline="true"
            />
            <p v-else class="no-cards">{{ $t('cards.no_cards') }}</p>
        </div>
    </default-sidebar>
</template>

<script>
    import DefaultSidebar from "./DefaultSidebar";
    import CardBoxesContainer from "../containers/CardBoxesContainer";

    export default {
        name: "OfflineCardsListSidebar",
        components: {
            DefaultSidebar,
            CardBoxesContainer,
        },
        computed: {
            offlineCards() {
                return this.$store.state.views.offlineCards;
            },
        },
    }
</script>

<style scoped lang="scss">
.no-cards {
    text-align: center;
    opacity: 0.6;
}
</style>
